import * as PIXI from "pixi.js";
import { SpineManager } from "../../game/manager/SpineManager";
import { EventHandler } from "../../util/event/EventHandler";
import { AssetLoader } from "../asset/AssetLoader";
/*
 * ComponentLoader.ts
 */
export class ComponentLoader {
    constructor(request, id) {
        this.request = request;
        this.id = id;
    }
    createAssetLoader() {
        this.assetLoader = new AssetLoader(this.assets);
        this.assetLoader.onProgress = this.handleAssetLoaderProgress.bind(this);
        this.assetLoader.onComplete = this.handleAssetLoaderComplete.bind(this);
    }
    async createPixiLoader() {
        PIXI.Assets.addBundle(this.id, this.pixiAssets);
        PIXI.Assets.loadBundle(this.id, this.handlePixiLoaderProgress.bind(this)).then(() => {
            console.log(`${this.id}: assets loaded`);
            this.handlePixiLoaderComplete();
        }).catch((error) => {
            console.log(`${this.id}: assets failed!`);
            console.info(error);
        });
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    onProgress(handler, scope) {
        this.progressHandler = new EventHandler(handler, scope);
    }
    load(components) {
        this.components = components;
        this.reset();
        this.processComponents();
        this.createAssetLoader();
        this.createPixiLoader();
    }
    reset() {
        this.progress = 0;
        this.pixiAssets = [];
        this.assets = [];
        this.largeFiles = [];
    }
    dispose() {
        this.assetLoader = null;
        this.request = null;
    }
    processComponents() {
        for (let component of this.components) {
            this.processComponent(component);
        }
    }
    processComponent(component) {
        let filePaths = component.getFilePaths();
        let filePath;
        for (let i = 0; i < filePaths.length; i++) {
            filePath = filePaths[i];
            let lazy = filePath.isLazy();
            if (lazy) {
                ComponentLoader.LAZY.push(filePath);
            }
            else {
                if (filePath.isFile()) {
                    this.pixiAssets.push({ alias: filePath.getId(), src: filePath.getUrl() });
                }
                else if (filePath.isVideo()) {
                    this.assets.push(filePath);
                    this.largeFiles.push(filePath);
                }
                else if (filePath.isSound()) {
                    this.assets.push(filePath);
                    this.largeFiles.push(filePath);
                }
                else if (filePath.isLang()) {
                    this.assets.push(filePath);
                }
                else if (filePath.isAtlas()) {
                    this.assets.push(filePath);
                }
                else if (filePath.isImage()) {
                    this.pixiAssets.push({ alias: filePath.getId(), src: filePath.getUrl() });
                }
                else if (filePath.isSpine()) {
                    this.assets.push(filePath);
                }
                else {
                    this.pixiAssets.push({ alias: filePath.getId(), src: filePath.getUrl() });
                }
            }
        }
    }
    handleAssetLoaderProgress(progress) {
        this.handleProgress(progress);
    }
    handlePixiLoaderProgress(progress) {
        this.handleProgress(progress);
    }
    handleAssetLoaderComplete() {
        this.handleComplete();
    }
    handlePixiLoaderComplete() {
        if (this.assets.length > 0) {
            this.assetLoader.load();
        }
        else {
            this.handleComplete();
        }
    }
    handleProgress(progress) {
        const largeFilesRemaining = Math.min(this.largeFiles.length, this.assets.length - this.assetLoader.loadCount);
        const pixiProgressMax = (this.pixiAssets.length / (largeFilesRemaining + this.pixiAssets.length)) * 100;
        const pixiProgress = Math.round(progress);
        const progressMin = Math.min(pixiProgressMax, pixiProgress);
        if (progressMin > this.progress && progress <= 100) {
            this.progress = progress;
        }
        this.callHandler(this.progressHandler);
    }
    handleComplete() {
        this.processTextures();
        this.callHandler(this.completeHandler);
    }
    processTextures() {
        for (let component of this.components) {
            let filePaths = component.getFilePaths();
            for (let filePath of filePaths) {
                let url = filePath.getUrl();
                if (filePath.isSpriteSheet()) {
                    if (PIXI.Assets.cache.has(filePath.getId())) {
                        let resource = PIXI.Assets.get(filePath.getId());
                        let frames = resource?.data?.frames;
                        for (let texture in frames) {
                            component.addTexture(texture);
                        }
                    }
                }
                else if (filePath.isImage()) {
                }
                else if (filePath.isSpine()) {
                    SpineManager.getInstance().addLazyLoaded(filePath.getUrl(), filePath.getAtlasUrl(), filePath.getUrl(), filePath.getScale());
                }
            }
        }
    }
    callHandler(handler) {
        if (handler) {
            handler.call(this);
        }
    }
    getProgress() {
        return this.progress;
    }
}
ComponentLoader.LAZY = [];
//# sourceMappingURL=ComponentLoader.js.map